import firstBankIcon from '../asset/providers/bank1.svg'
import secondBankIcon from '../asset/providers/bank2.svg'
import thirdBankIcon from '../asset/providers/bank3.svg'
import fourthBankIcon from '../asset/providers/bank4.svg'
import fifthBankIcon from '../asset/providers/bank5.svg'
import sixthBankIcon from '../asset/providers/bank6.svg'
import seventhBankIcon from '../asset/providers/bank7.svg'

const radioData = [
  {
    imgSrc: firstBankIcon,
    text: 'Bank 1',
  },
  {
    imgSrc: secondBankIcon,
    text: 'Bank 2',
  },
  {
    imgSrc: thirdBankIcon,
    text: 'Bank 3',
  },
  {
    imgSrc: fourthBankIcon,
    text: 'Bank 4',
  },
  {
    imgSrc: fifthBankIcon,
    text: 'Bank 5',
  },
  {
    imgSrc: sixthBankIcon,
    text: 'Bank 6',
  },
  {
    imgSrc: seventhBankIcon,
    text: 'Bank 7',
  },
]

export default radioData
